<div class="wrapper" *ngIf="!disabled">
  <div class="contentOptions">
    <div class="search" (click)="show = true">
      <div *ngIf="!app.field.isMultiple(field)">
        <input
          type="text"
          class="w-100 optionsInput"
          (click)="showOptions(true)"
          [(ngModel)]="search"
          [placeholder]="getPlaceholder(field)"
        />
      </div>
      <span class="m-0" *ngIf="search != '' ">
        <button class="btn clearButton" (click)="clearModel()">
          <i class="fas fa-times-circle clearIcon"></i> {{app.text.import.clear}}
        </button>
      </span>
      <span class="searchIcon" *ngIf="!isMandatory() && search == ''">
        <i class="fa fa-search"></i>
      </span>

      <div *ngIf="app.field.isMultiple(field) && !show">
        <input
          type="text"
          class="w-100 searchInput"
          (click)="showOptions(true)"
        />
        <small
          class="badge selected m-1"
          *ngFor="let option of model[field]"
          (click)="toggleOption(field, option, model); show = false"
        >
          {{ app.users.getOptionName(option) }}
          &nbsp;
          <i class="fa fa-times"></i>
        </small>
      </div>
      <span class="invalidspan" *ngIf="isMandatory()"
        ><i
          class="fal fa-exclamation-circle"
          tooltipClass="customTooltip"
          [ngbTooltip]="app.text.field.requiredIcon"
        ></i
      ></span>
    </div>
  </div>
  <div *ngIf="show" style="max-height: 250px; overflow-y: scroll">
    <!-- selected options if the field is type multiple -->
    <button
      class="btn"
      type="button"
      (click)="show = false"
      *ngIf="app.field.isMultiple(field)"
    >
      <i class="fa fa-times"></i>
      {{ app.text.user.closeBtn }}
    </button>
    <div *ngFor="let option of app.field.getUserOptions(field); let i = index">
      <button
        *ngIf="isMatch(search, option.name) && !app.field.isMultiple(field)"
        class="btn btn-sm optionsName"
        (click)="
          $event.stopPropagation();
          toggleOption(field, option, model);
          selected.next(option)
        "
      >
        {{ option.name }}
      </button>

      <div *ngIf="app.field.isMultiple(field)">
        <button
          class="btn btn-sm"
          (click)="
            $event.stopPropagation();
            toggleOption(field, option, model);
            selected.next(option)
          "
        >
          <input
            type="checkbox"
            [checked]="app.field.isOptionSelected(field, option.id, model)"
            *ngIf="app.field.isMultiple(field) && app.filterList.field == null"
          />
          {{ option.name }}
        </button>
      </div>
    </div>
  </div>
</div>
<div
  *ngIf="model[field] != null && disabled && !app.field.isMultiple(field)"
  class="m-1"
>
  {{ app.users.getOptionName(model[field]) }}
  <!-- DISPLAYED ONLY FOR DB -->
  <button
    class="btn responsible-bullet"
    *ngIf="getFieldType(field, model[field]) === 'responsible'"
    [ngbTooltip]="app.text.impact.wfResponsible"
  >
    <i
      class="fad fa-user-times"
      *ngIf="
        app.impact.displayBullet(field, red) &&
        model[field] !== '' &&
        app.unlockedId !== app.thread.id
      "
    ></i>
    <i
      class="fad fa-user-times fa-deputy"
      *ngIf="
        app.impact.displayBullet(app.fieldId.thread.dinCodeRespName, red) &&
        field === app.fieldId.thread.deputy &&
        model[app.fieldId.thread.deputy] !== '' &&
        app.unlockedId !== app.thread.id
      "
    >
    </i>
  </button>
</div>
<div
  *ngIf="
    model[field] != null &&
    disabled &&
    app.field.isMultiple(field) &&
    app.unlockedId == null
  "
>
  <span *ngFor="let option of model[field]">
    {{ app.users.getOptionName(option) }}
  </span>
</div>
<!-- USED FOR PREPOPULATION OF SOME FIELDS (IMPACT CREATION - DB) -->
<div *ngIf="app.state.createMode">
  <span>
    {{ app.users.getOptionName(model[field]) }}
  </span>
</div>
